import Slider, { type SliderProps } from 'rc-slider';

import styles from './input-range-slider.module.scss';

interface InputSliderProps extends Omit<SliderProps, 'onChange' | 'value'> {
  onChange: (value: number) => void;
  value: number;
}

export default function InputSlider(props: InputSliderProps) {
  const {
    max,
    min,
    onChange,
    step,
    value,
  } = props;

  const handleChange = (sliderValue: number | number[]) => {
    if (!Array.isArray(sliderValue)) {
      onChange(sliderValue);
    }
  };

  return (
    <div className={styles.slider}>
      <div className={styles.slider_input}>
        <Slider
          step={step}
          value={value}
          allowCross={false}
          min={min}
          max={max}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}
